import { Box, Grid2 } from "@mui/material";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";
import {
  handleChange,
  handleIp,
  handlePortScan,
} from "../../../utils/helpers/portScannerHelpers";

import {
  useI18ports,
  usePortScanner,
  usePortScannerAdapter,
} from "../../../hooks";

import {
  BoxWrapper,
  Container,
  CustomSuBAndDescription,
  Input,
  ProgressBar,
} from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import AccordionTable from "../../../components/common/AccordionTable";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import Spinner from "../../../components/common/Spinner";
import { Button } from "../../../components/ui/Button/Button";
import { SelectAndSearch } from "../../../components/ui/SelectAndSearch/SelectAndSearch";
import { InsertIp } from "./InsertIp/InsertIp";
import { addStyles } from "./addStyles";

import { Section } from "../../../components/common/Section/Section.styled";
import { WrapperTable } from "./PortScanner.styled";

const PortScanner = () => {
  const { ports } = useI18ports();

  const {
    showLoader,
    setShowLoader,
    formData,
    setFormData,
    responseFromServer,
    setResponseFromServer,
    form,
    t,
  } = usePortScanner();

  const {
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
    headerData,
  } = usePortScannerAdapter();

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          {showLoader && <ProgressBar onFinish={() => setShowLoader(false)} />}

          <BoxWrapper>
            <CustomSuBAndDescription
              sub={t("portScanner.formTitle")}
              desc={t("portScanner.formDescription")}
            />

            <Box>
              <form
                ref={form}
                onSubmit={e =>
                  handlePortScan(
                    e,
                    form,
                    formData,
                    setShowLoader,
                    setResponseFromServer,
                    t,
                  )
                }
              >
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Input
                      name={"ip"}
                      className="grey"
                      fullWidth
                      placeholder={t("portScanner.inputPlaceholder")}
                      value={formData.ip}
                      addStyles={addStyles.input}
                      onChange={e => handleChange(e, setFormData)}
                    />
                    <InsertIp
                      handleIp={() => handleIp(setFormData)}
                      text={t("portScanner.label")}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <SelectAndSearch
                      name="portType"
                      selectName="port"
                      // data={t("portScanner.popularPorts", {
                      //   returnObjects: true,
                      // })}
                      data={ports}
                      isLoading={false}
                      placeholder={t("portScanner.selectPlaceholder")}
                      type="filter"
                      handleChange={e => handleChange(e, setFormData)}
                      addStyle={addStyles.addStyleSelect}
                    />
                  </Grid2>
                </Grid2>

                <Button
                  type={"submit"}
                  disable={showLoader}
                  styles={addStyles.button}
                  fullWidth
                >
                  {showLoader ? (
                    <Spinner text={t("portScanner.button")} />
                  ) : (
                    t("portScanner.button")
                  )}
                </Button>
              </form>

              {responseFromServer && !showLoader && (
                <WrapperTable>
                  <AccordionTable
                    data={responseFromServer?.ports}
                    headerData={headerData}
                    renderRowContent={renderRowContent}
                    renderDropdownContent={renderDropdownContent}
                    renderHeaderTitle={renderHeaderTitle}
                    showStatus={true}
                    gridSettings={"100px 150px 1fr"}
                  />
                </WrapperTable>
              )}
            </Box>
          </BoxWrapper>
        </Container>
      </Section>

      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

PortScanner.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default PortScanner;
